import { addListener } from '../../Foundation/history.js'
import { loadHtml } from './State/api.js'


Foundation.ReactiveComponent = class ReactiveComponent {
  constructor (componentId, el, options) {
    this.componentId = componentId
    this.ref = jQuery(el)
    this.initialUrl = window.location.href
    this.watchUrl()

    this.onBeginLoad = options.onBeginLoad 
    this.onSuccess = options.onSuccess

    this.noCacheUrlBase = options.noCacheUrlBase || ''
    this.noCacheParamKeyValues = options.noCacheParamKeyValues || {}

    Foundation.Page.Reactive = Foundation.Page.Reactive || {} 
    Foundation.Page.Reactive[this.componentId] = this
  }

  watchUrl () {
    addListener((location, _action) => {
      this.requestUpdate(location).then((html) => this.applyUpdate(html))
    })
  }

  update () {
      this.requestUpdate(location).then((html) => this.applyUpdate(html))
  }

  useNonCachedUrl () {
    var endpoint = new URL(window.location.href)
    for (let prop in this.noCacheParamKeyValues) {
      if (endpoint.searchParams.get(prop) === this.noCacheParamKeyValues[prop]) {
        return true;
      }
    }
    return false;
  }

  requestUpdate () {
    var endpoint = new URL(window.location.href)
    var cachBust = new Date().getTime()

    if (this.useNonCachedUrl() && this.noCacheUrlBase) {
      endpoint.searchParams.append('cb', cachBust)
    }

    endpoint.searchParams.append('ajaxComponent', this.componentId);

    if ( this.onBeginLoad ) {
      this.onBeginLoad(this.ref)
    }

    return loadHtml(endpoint)
  }

  applyUpdate (html) {
    var replacement = jQuery(html)
    this.ref.replaceWith(replacement)
    this.ref = replacement 
    if ( this.onSuccess ) {
      this.onSuccess(this.ref)
    }
  }
}


window.Foundation.ReactiveComponent = Foundation.ReactiveComponent
